export const firebaseConfig = {
    apiKey: "AIzaSyAnFWFGRVnSTKm7vqg4NR3AYSUkMkzZM6o",
    authDomain: "portfolio-1599c.firebaseapp.com",
    databaseURL: "https://portfolio-1599c-default-rtdb.firebaseio.com",
    projectId: "portfolio-1599c",
    storageBucket: "portfolio-1599c.appspot.com",
    messagingSenderId: "307158814152",
    appId: "1:307158814152:web:d7fa06f466f370bb7cc4fd",
    measurementId: "G-ZF11D80RDH"
  };